export default __webpack_public_path__ + "static/first-soloists-d035572af7a8a6bec3a34d301a64385e.jpg";